import { FC, useEffect, useState } from 'react'
import './Onboarding.scss'
import React from 'react'
import Select from 'react-select'

type OnboardingQuestion = {
  questionId: string;
  title: string;
  options: string[];
  subTitle: string;
  other: {
    title: string;
    options: string[];
  }
  answer?: string | string[] | null;
}

type CompoundSingleSelectProps = {
  data: OnboardingQuestion
  setIsDisable: (value: boolean) => void;
  onSubmit: (answer: string | null | Record<string, string>) => void;
}

const CompoundSingleSelect: FC<CompoundSingleSelectProps> = ({ data, setIsDisable, onSubmit }) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(data?.answer as string ?? null);

  const handleChange = (option: string) => {
    setSelectedOption(option);
    if (!option.includes('Other')) {
      setIsDisable(false);
      onSubmit({ [`${data.questionId}`]: option })
    } else {
      setIsDisable(true);
    }
  };

  useEffect(() => {
    if (selectedOption) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.answer]);

  const isMultipleColumn = false;

  return (
    <>
      <div className='fw-boldest fs-3'>{data.title}</div>
      <div className='onboarding-description'>{data.subTitle}</div>
      <div className={`gap-4 mt-10 ${isMultipleColumn ? 'd-flex flex-wrap' : ''}`}>
        {data.options.map((opt) => (
          <div
            key={opt}
            className='form-check form-check-custom form-check-solid mb-5'
            style={isMultipleColumn ? { width: 'calc(50% - 1rem)' } : {}}
            onChange={() => handleChange(opt)}
          >
            <input
              className='form-check-input widget-9-check radio-input'
              type='checkbox'
              id={opt}
              name={data.title}
              value={opt}
              checked={selectedOption === opt}
              onChange={() => handleChange(opt)}
            />
            <label className='form-check-label option-label' htmlFor={opt}>
              {opt}
            </label>
          </div>
        ))}
        <div
          className='form-check form-check-custom form-check-solid mb-5'
          onChange={() => handleChange(data.other.title)}
        >
          <input
            className='form-check-input widget-9-check radio-input'
            type='checkbox'
            id={data.other.title}
            name={data.other.title}
            value={data.other.title}
            checked={(selectedOption === data.other.title) || data?.other?.options.includes(selectedOption as string)}
            onChange={() => handleChange(data.other.title)}
          />
          <label className='form-check-label option-label' htmlFor={data.other.title}>
            {data?.other?.title}
          </label>
        </div>

        {selectedOption?.includes('Other') || data?.other?.options.includes(selectedOption as string) ? (
          <div className='select-other'>
            <label className='form-check-label' htmlFor={'other'}>
              SMS Platform that you use
            </label>
            <Select
              styles={{
                container: (provided) => ({
                  ...provided,
                  background: '#FFFFFF'
                }),
                control: (provided) => ({
                  ...provided,
                  background: '#FFFFFF'
                }),
              }}
              value={
                selectedOption
                  ?
                  {
                    label: selectedOption,
                    value: selectedOption,
                  } : null
              }
              onChange={(e: any) => handleChange(e.value)}
              options={data?.other?.options?.map(option => ({ label: option, value: option }))}
              placeholder={'Select your SMS Platform'}
              className='form-select form-select-solid'
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default React.memo(CompoundSingleSelect)
